module.exports = __webpack_public_path__ + "falha_api.png?be3185d8a569efb4592b1c5e0d9ea983";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/falha_api.png
// module id = 431
// module chunks = 0